import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  Battery5BarOutlined,
  BoltOutlined,
  ReceiptLongOutlined,
  SpaceDashboardOutlined,
} from '@mui/icons-material';

const FEATURES = [
  {
    icon: <SpaceDashboardOutlined fontSize="small" />,
    title: "Live site overview",
    text: "Grid, solar, load and storage in one view, refreshed every few seconds.",
  },
  {
    icon: <Battery5BarOutlined fontSize="small" />,
    title: "Battery and PCS health",
    text: "State of charge, temperatures and power conversion per unit.",
  },
  {
    icon: <ReceiptLongOutlined fontSize="small" />,
    title: "Utility bill savings",
    text: "Monthly bills compared with and without battery storage.",
  },
];

// Left half of the login page: brand, welcome message and what the portal offers
const WelcomePanel = () => (
  <Box sx={{
    position: "relative",
    display: { xs: "none", md: "flex" },
    flexDirection: "column",
    justifyContent: "space-between",
    flex: "1 1 55%",
    minHeight: "100vh",
    p: { md: 5, lg: 7 },
    boxSizing: "border-box",
    color: "#FFF7ED",
    overflow: "hidden",
  }}>
    {/* Brand */}
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
      <Box sx={{
        width: 40,
        height: 40,
        borderRadius: "10px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #3B9BFF 0%, #137FEC 55%, #142784 100%)",
        boxShadow: "0 6px 20px rgba(19, 127, 236, 0.45)",
      }}>
        <BoltOutlined sx={{ color: "white" }} />
      </Box>
      <Box>
        <Typography sx={{ fontSize: 18, fontWeight: 700, lineHeight: 1.2 }}>POSH Energy</Typography>
        <Typography sx={{
          fontSize: 11,
          fontWeight: 500,
          letterSpacing: "0.1em",
          textTransform: "uppercase",
          color: "rgba(255, 244, 232, 0.6)",
        }}>
          Energy Management System
        </Typography>
      </Box>
    </Box>

    {/* Welcome message */}
    <Box sx={{ maxWidth: 520 }}>
      <Typography component="h2" sx={{
        fontSize: { md: 36, lg: 44 },
        fontWeight: 700,
        lineHeight: 1.15,
        letterSpacing: "-0.02em",
      }}>
        Your energy sites, at a glance.
      </Typography>
      <Typography sx={{ fontSize: 17, lineHeight: 1.6, color: "rgba(255, 244, 232, 0.75)", mt: 2 }}>
        Monitor production, storage and consumption across your locations, and see what your battery saves you every month.
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5, mt: 5 }}>
        {FEATURES.map((feature) => (
          <Box key={feature.title} sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
            <Box sx={{
              width: 36,
              height: 36,
              flexShrink: 0,
              borderRadius: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(255, 244, 232, 0.1)",
              border: "1px solid rgba(255, 244, 232, 0.15)",
              backdropFilter: "blur(8px)",
            }}>
              {feature.icon}
            </Box>
            <Box>
              <Typography sx={{ fontSize: 15, fontWeight: 600 }}>{feature.title}</Typography>
              <Typography sx={{ fontSize: 14, color: "rgba(255, 244, 232, 0.65)", lineHeight: 1.5 }}>
                {feature.text}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>

    <Typography sx={{ fontSize: 13, color: "rgba(255, 244, 232, 0.5)" }}>
      © {new Date().getFullYear()} POSH Energy
    </Typography>
  </Box>
);

export default WelcomePanel;
